<template>
    <div @mousewheel.prevent>
        <div class="main">
            <div class="pop">
                <div class="pop-top">
                    <div class="hd bxli">
                        <p v-if="payUse == 1">开通会员</p>
                        <p v-if="payUse == 2">立即续费</p>
                        <div class="top-right">
                            <!-- <el-button @click="payFinish()" v-show="showCode" size="small" type="primary">支付完成</el-button> -->
                            <el-button size="small" @click="close()">关闭</el-button>
                        </div>
                    </div>
                </div>
                <div class="bxli" v-if="!showCode" v-loading="loading">
                    <div class="select">
                        <div class="option" v-for="(item,index) in datalist" :key='index' :class="{ xzl: curIndex == index }" @click="select(1, index)">
                            <p class="h2">
                                <span>{{ Number(item.price).toFixed(2) }}</span>元/{{item.month==1?'月':item.month==6?'半年':'年'}}
                            </p>
                            <p class="h3">
                                <span>{{ parseFloat(item.price / (item.month)).toFixed(2) }}</span>元/月
                            </p>
                        </div>
                    </div>
                    <div class="item">
                        <p>到期时间：</p>
                        <p>{{getTime(currentTime)}}</p>
                    </div>
                    <div class="item" style="margin-top: 10px">
                        <p>支付方式：</p>
                    </div>
                    <div class="pay">
                        <div class="paytype" @click="radio = 0">
                            <div class="circle" :class="{ circleblue: radio == 0 }">
                                <div class="circli"></div>
                            </div>
                            <img src="@/assets/img/vip/wechat.png" alt="" />
                            <p :class="{ blue: radio == 0 }">微信支付</p>
                        </div>
                        <div class="paytype" @click="radio = 1">
                            <div class="circle" :class="{ circleblue: radio == 1 }">
                                <div class="circli"></div>
                            </div>
                            <img src="@/assets/img/vip/pay.png" alt="" />
                            <p :class="{ blue: radio == 1 }">支付宝支付</p>
                        </div>
                    </div>
                    <div class="zhifu">
                        <div class="txt">
                            <p class="h2">
                                实付金额：<span>¥{{ sum }}</span>
                            </p>
                            <p class="h3">完成支付后可在个人中心 - 购买记录中查看</p>
                        </div>
                        <a href="javascript:;" class="fukuan" @click="topaystate">立即支付</a>
                    </div>
                </div>
                <div class="code-con" v-else>
                    <img class="success" src="@/assets/img/vip/success.png" alt="">
                    <p class="h1">订单提交成功</p>
                    <p class="h2">应付金额：<span>¥{{sum}}</span></p>
                    <p class="h3">请在30分钟内完成支付</p>
                    <div class="ewm">
                        <div id="qrcode"></div>
                    </div>
                    <p class="h3">请使用{{radio==0?'微信':'支付宝'}}扫一扫支付</p>
                </div>
            </div>
        </div>
        <div v-html="alipayWap" ref="alipayWap"></div>
    </div>
</template>

<script>
import QRCode from "qrcodejs2";
export default {
    components: {},
    data() {
        return {
            datalist: [{month:1}], //获取数据
            memberType: "", //会员类型（1个人 2企业）
            payUse: "", //订单类型（1 新开 2续费）
            num: "", //人数
            radio: 0, //按钮
            curIndex: 0, //支付选择
            sum: "", //开通总价
            currentTime: "", //当前时间或到期时间
            month: 1, //开通期限,
            alipayWap: "",
            qianHtml: "",
            showCode: false,
            orderId: "",
            timer: "",
            loading: false
        };
    },
    methods: {
        getTime(time) {
            let arr=time.split('-');
            let yy = arr[0];
            let mm = Number(arr[1])+Number(this.datalist[this.curIndex].month);
            let dd = arr[2];
            if(mm>12){
                yy++;
                mm=mm-12;
            }
            return (
                yy + "-" + (mm < 10 ? "0" + mm : mm) + "-" + dd
            );
        },
        payFinish() {
            this.$http.get(`/app/order/info/${this.orderId}`).then(res => {
                if (res.data.data == 1) {
                    clearInterval(this.timer);
                    this.showCode = false;
                    this.$http.post("app/userInfo").then(res => {
                        if (res.data.code == 0) {
                            this.$store.commit("setUser", res.data.data);
                            this.close();
                            this.$router.push("/home");
                        }
                    });
                    this.$message.success("支付成功,自动跳转到首页！");
                }
            });
        },
        qrcode(url) {
            let qrcode = new QRCode("qrcode", {
                width: 170,
                height: 170, // 高度
                text: url, // 二维码内容
                background: "#fff"
            });
        },
        select(state, index) {
            this.curIndex = index;
            this.month = this.datalist[index].month;
            this.sum = Number(this.datalist[index].price).toFixed(2);
        },
        close() {
            clearInterval(this.timer);
            this.showCode = false;
            this.$parent.closeVip(this.isSuccess);
        },
        getSrcList(json) {
            this.memberType = json.memberType;
            this.payUse = json.payUse;
            this.datalist = json.memberTypearry;
            this.curIndex = json.index;
            console.log(json.end,888)
            this.currentTime = json.end;
            this.sum = this.datalist[this.curIndex].price
            
            console.log(json,999)
        },
        topaystate() {
            let url = "";
            let json = {
                memberType: this.memberType,
                num: 1,
                payUse: this.payUse,
                type: Number(this.datalist[this.curIndex].month),
                year:Number(this.datalist[this.curIndex].month),
                version:2
            };
            if (this.radio == 0) {
                this.loading = true;
                url = "/app/order/wechatPayCode";
                this.$http.post(url, json).then(res => {
                    this.loading = false;
                    if (res.data.code == 0) {
                        this.showCode = true;
                        this.orderId = res.data.data.orderId;
                        const that = this;
                        this.$nextTick(function () {
                            that.qrcode(res.data.data.qrCodeUrl);
                        });
                        this.timer = setInterval(this.payFinish, 2000);
                    }
                });
            } else if (this.radio == 1) {
                url = "/app/order/alipcPay";
                var self = this;
                this.$http.post(url, json).then(res => {
                    const div = document.createElement("div");
                    div.innerHTML = res.data;
                    document.body.appendChild(div);
                    document.forms[0].submit();
                });
            }
        }
    },
    beforeDestroy() {
        clearInterval(this.timer);
    }
};
</script>

<style lang="less" scoped>
.code-con {
  width: 80%;
  margin: 0 auto;
  padding: 30px 0;
  text-align: center;

  .success {
    margin: 0 auto 20px;
  }

  p {
    letter-spacing: 1px;
    text-align: center;
  }

  .h1 {
    font-size: 16px;
    font-weight: 600;
    color: #0c1f3d;
  }

  .h2 {
    font-size: 14px;
    color: #666666;
    padding: 24px 0 8px;

    span {
      font-size: 18px;
      font-weight: 600;
      color: #3779ff;
    }
  }

  .h3 {
    font-size: 12px;
    color: #999999;
  }

  .ewm {
    background-color: #ffffff;
    border: solid 1px #cccccc;
    margin: 18px auto 14px;
    padding: 15px;
    width: 170px;
    text-align: center;
  }

  .h4 {
    font-size: 12px;
    color: #666666;
  }
}

.main {
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.4);
  display: flex;
  justify-content: center;
  align-items: center;
  position: fixed;
  top: 0;
  z-index: 99;

  .pop {
    width: 600px;
    background-color: #ffffff;
    position: fixed;
    top: 20%;
    left: 0;
    right: 0;
    margin: auto;

    .bxli {
      width: 94%;
      margin: 0 auto;
    }

    .pop-top {
      width: 600px;
      height: 60px;
      border-bottom: 1px solid #eeeeee;

      .hd {
        display: flex;
        justify-content: space-between;
        align-items: center;
        height: 60px;

        p {
          font-size: 16px;
          font-weight: 600;
          letter-spacing: 1px;
          color: #333333;
          height: 16px;
          line-height: 16px;
          padding-left: 10px;
          border-left: 3px solid #3779ff;
        }

        .top-right {
          letter-spacing: 1px;
        }

        .pay-finish {
          width: 64px;
          height: 30px;
          background-color: #3779ff;
          border-radius: 2px;
          border: solid 1px #3779ff;
          font-size: 12px;
          color: #fff;
          text-align: center;
          line-height: 30px;
          cursor: pointer;
        }

        .colse {
          width: 64px;
          height: 30px;
          background-color: #ffffff;
          border-radius: 2px;
          border: solid 1px #cccccc;
          font-size: 12px;
          letter-spacing: 1px;
          color: #333333;
          text-align: center;
          line-height: 30px;
          cursor: pointer;
        }
      }
    }

    .select {
      width: 560px;
      display: flex;
      justify-content: space-between;
      margin: 20px auto 28px;

      .option {
        width: 174px;
        height: 100px;
        border-radius: 6px;
        background: url("../assets/img/vip/grayxf.png") no-repeat center center;
        background-size: cover;
        transition: all 0.5s;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        .h2 {
          font-size: 16px;
          color: #333333;
          font-weight: 600;

          span {
            font-size: 24px;
            color: #ffb32f;
          }
        }

        .h3 {
          font-size: 12px;
          color: #666666;
          padding-top: 8px;

          span {
            color: #ffb32f;
          }
        }

        .span-b {
          span {
            color: #3176fc;
          }
        }
      }

      .xzl {
        box-shadow: 0px 2px 8px 0px #c2d7ff;
        background: url("../assets/img/vip/bluexf.png") no-repeat center center;
        background-size: cover;
      }
    }

    .item {
      display: flex;
      justify-content: space-between;

      p {
        font-size: 14px;
        color: #333333;
        margin-bottom: 16px;
      }
    }

    .pay {
      display: flex;

      .paytype {
        width: 180px;
        height: 56px;
        background-color: #f5f5f5;
        border-radius: 4px;
        margin-right: 20px;
        cursor: pointer;
        display: flex;
        justify-content: center;
        align-items: center;

        .circle {
          width: 14px;
          height: 14px;
          border-radius: 50%;
          border: solid 1px #cccccc;
          display: flex;
          justify-content: center;
          align-items: center;
          transition: all 0.5s;

          .circli {
            width: 8px;
            height: 8px;
            border-radius: 50%;
            background-color: #3779ff;
            opacity: 0;
            transition: all 0.5s;
          }
        }

        .circleblue {
          border: solid 1px #3779ff;

          .circli {
            opacity: 1;
          }
        }

        img {
          margin: 0 10px;
        }

        .blue {
          color: #3779ff;
        }
      }
    }

    .zhifu {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin: 42px 0 20px 0;

      .txt {
        .h2 {
          font-size: 14px;
          color: #333333;

          span {
            font-size: 22px;
            font-weight: 600;
            color: #3176fc;
          }
        }

        .h3 {
          font-size: 10px;
          color: #999999;
        }
      }

      .fukuan {
        width: 200px;
        height: 48px;
        background-color: #3779ff;
        border-radius: 4px;
        font-size: 16px;
        font-weight: 600;
        color: #ffffff;
        text-align: center;
        line-height: 48px;
      }
    }
  }
}
</style>
